import { useState, useEffect } from 'react'
import AuthService from 'services/auth'
import cutileiApi from 'services/cutileiApi'
import { logApiError } from 'services/apiError'
import CustomMessageModal from 'pages/Modals/CustomMessageModal'
import CustomMessageList from 'components/Lists/CustomMessageList'
import { ReactComponent as Loading } from 'icons/loading2.svg'
import { Container, Row, SubTitle, InfoText, Button } from '../../styles'
import SecondaryButton from 'components/Buttons/SecondaryButton'

export default function EditCustomMessages () {
  const [loading, setLoading] = useState (true)
  const [customMessages, setCustomMessages] = useState ([])
  const [showCreateCustomMessageModal, setShowCreateCustomMessageModal] = useState (false)
  const hasEditPermission = AuthService.hasPermission ('business_config.agenda', 'edit')
  const businessId = AuthService.getBusinessId ()
  const token = AuthService.getToken ()

  const requestConfig = {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  }

  useEffect (() => {
    getData ()
  }, [])

  const getData = async () => {
    try {
      const { data: customMessages } = await cutileiApi.get (
        `/businesses/${businessId}/custom_messages`, requestConfig
      )

      setCustomMessages (customMessages)
    } catch (error) {
      logApiError (error)
    } finally {
      setLoading (false)
    }
  }

  const toggleCreateCustomMessageModal = () => (
    setShowCreateCustomMessageModal (!showCreateCustomMessageModal)
  )

  if (loading) return <Loading style={{marginTop: 30}}/>

  return (
    <Container>
      <SubTitle>Mensagens personalizadas</SubTitle>
      <Row>
        <InfoText>
          Crie mensagens personalizadas para enviar aos seus clientes.<br/>
          Você poderá escolher uma dessas mensagens através do painel de detalhes dos agendamentos no botão "Falar com cliente".
        </InfoText>
      </Row>
      {hasEditPermission && (
        <Row>
          <SecondaryButton
            label='Criar mensagem'
            onClick={toggleCreateCustomMessageModal}
            width={160}
          />
          <CustomMessageModal
            visible={showCreateCustomMessageModal}
            onClose={toggleCreateCustomMessageModal}
            onConfirm={customMessage => setCustomMessages (prev => [...prev, customMessage])}
          />
        </Row>
      )}
      <CustomMessageList
        customMessages={customMessages}
        onEdit={customMessage => setCustomMessages (prev => (
          prev.map (cm => cm.id === customMessage.id ? customMessage : cm)
        ))}
        onDelete={customMessage => {
          setCustomMessages (prev => prev.filter (cm => cm.id !== customMessage.id))
        }}
      />
    </Container>
  )
}
